/**
 * Mock Marketplace Service
 * 
 * Simulated backend service for the Marketplace feature.
 * Handles product data, categories, and provider listings.
 */

// Mock Data
let PRODUCTS = [
    {
        id: 'prod_1',
        title: 'Premium Dog Food (Chicken & Rice Formula)',
        description: 'Provide your canine companion with the nutrition they deserve. Our Premium Chicken & Rice Formula is crafted with real, farm-raised chicken as the #1 ingredient. \n\nFeatures:\n• High-quality protein for muscle maintenance\n• Omega-3 and Omega-6 fatty acids for a shiny coat\n• No artificial preservatives or fillers\n• Suitable for all breeds and life stages\n\nNet Weight: 15kg',
        price: 249.99,
        currency: 'SAR',
        country: 'Saudi Arabia',
        city: 'Riyadh',
        category: 'food',
        image: 'https://images.unsplash.com/photo-1589924691195-41432c84c161?q=80&w=1000&auto=format&fit=crop',
        rating: 4.8,
        reviews: 342,
        providerId: 'prov_1',
        providerName: 'Happy Pets Shop',
        stock: 25,
        reviewsData: [
            { id: 1, user: "Emily R.", rating: 5, date: "2023-12-01", comment: "My Golden Retriever loves this food! His coat is so shiny now." },
            { id: 2, user: "John D.", rating: 4, date: "2023-11-20", comment: "Good quality, but the bag is hard to reseal." },
            { id: 3, user: "Jessica W.", rating: 5, date: "2023-11-15", comment: "Best price I found online. Fast delivery properly packaged." }
        ]
    },
    {
        id: 'prod_2',
        title: 'Smart Automatic Water Fountain',
        description: 'Keep your pet hydrated all day long with our whisper-quiet Smart Water Fountain. The circulating filtration system ensures fresh, clean water is always available, encouraging your pet to drink more.\n\nSpecs:\n• Capacity: 2.5 Liters\n• Ultra-quiet pump (<30dB)\n• Triple-filtration system removes hair, dirt, and odors\n• USB powered with low energy consumption\n• LED water level indicator',
        price: 189.50,
        currency: 'SAR',
        country: 'Saudi Arabia',
        city: 'Riyadh',
        category: 'accessories',
        image: 'https://images.unsplash.com/photo-1545249390-6bdfa286032f?q=80&w=1000&auto=format&fit=crop',
        rating: 4.6,
        reviews: 89,
        providerId: 'prov_1',
        providerName: 'Happy Pets Shop',
        stock: 12
    },
    {
        id: 'prod_3',
        title: 'ToughChew Indestructible Rubber Toy',
        description: 'Got a heavy chewer? This toy is built to last. Made from non-toxic, industrial-strength natural rubber, it bounces unpredictably to keep your dog engaged for hours.\n\nBenefits:\n• Textured surface cleans teeth and massages gums\n• Hollow center can be stuffed with treats\n• Dishwasher safe for easy cleaning\n• Perfect for fetch and solo play',
        price: 45.00,
        currency: 'SAR',
        country: 'Saudi Arabia',
        city: 'Jeddah',
        category: 'toys',
        image: 'https://images.unsplash.com/photo-1576201836106-db1758fd1c97?q=80&w=1000&auto=format&fit=crop',
        rating: 4.9,
        reviews: 521,
        providerId: 'prov_2',
        providerName: 'Paws & Play',
        stock: 50
    },
    {
        id: 'prod_4',
        title: 'Luxury Orthopedic Pet Bed (Large)',
        description: 'Give your pet the ultimate sleep experience. Our orthopedic bed features high-density memory foam that contours to your pet\'s body, relieving joint pain and providing superior comfort.\n\nFeatures:\n• Removable, machine-washable plush cover\n• Non-slip bottom keeps bed in place\n• Waterproof liner protects memory foam\n• Dimensions: 100cm x 80cm x 15cm\n• Ideal for older pets or those with arthritis',
        price: 320.00,
        currency: 'SAR',
        country: 'Saudi Arabia',
        city: 'Jeddah',
        category: 'bedding',
        image: 'https://images.unsplash.com/photo-1518331647614-7a1f04cd34cf?q=80&w=1000&auto=format&fit=crop',
        rating: 4.7,
        reviews: 156,
        providerId: 'prov_2',
        providerName: 'Paws & Play',
        stock: 3
    },
    {
        id: 'prod_5',
        title: 'Deluxe Multi-Level Bird Cage',
        description: 'A spacious sanctuary for your feathered friends. This large bird cage offers plenty of room for parrots, cockatiels, and other birds to spread their wings.\n\nIncludes:\n• 4 Stainless steel feeder cups\n• 2 Wooden perches\n• Slide-out metal tray for easy cleaning\n• Heavy-duty castor wheels for mobility\n• Secure locking mechanism',
        price: 550.00,
        currency: 'SAR',
        country: 'Saudi Arabia',
        city: 'Dammam',
        category: 'habitats',
        image: 'https://images.unsplash.com/photo-1552053831-71594a27632d?q=80&w=1000&auto=format&fit=crop',
        rating: 4.4,
        reviews: 45,
        providerId: 'prov_1',
        providerName: 'Happy Pets Shop',
        stock: 0
    },
    {
        id: 'prod_6',
        title: 'Interactive Laser Cat Toy',
        description: 'Keep your cat active and entertained even when you\'re busy. This automatic laser toy creates random patterns on the floor and walls that cats love to chase.\n\n• Multiple speed settings (Slow, Fast, Random)\n• Automatic shut-off after 15 minutes\n• Quiet operation\n• Requires 4 AA batteries (not included)',
        price: 85.00,
        currency: 'SAR',
        country: 'United Arab Emirates', // Different Country
        city: 'Dubai',
        category: 'toys',
        image: 'https://images.unsplash.com/photo-1513201099705-a9746e1e201f?q=80&w=1000&auto=format&fit=crop',
        rating: 4.3,
        reviews: 210,
        providerId: 'prov_3',
        providerName: 'TechPets',
        stock: 10
    },
    {
        id: 'prod_7',
        title: 'Complete Aquarium Starter Kit (20L)',
        description: 'Start your aquatic journey with this all-in-one kit. Perfect for beginners and small fish.\n\nKit contains:\n• 20L Glass Tank with LED Hood\n• Internal Power Filter\n• Water Conditioner & Fish Food samples\n• Aquarium Heater\n• Setup Guide',
        price: 299.00,
        currency: 'SAR',
        country: 'Saudi Arabia',
        city: 'Riyadh',
        category: 'habitats',
        image: 'https://images.unsplash.com/photo-1522069169874-c58ec4b76be5?q=80&w=1000&auto=format&fit=crop',
        rating: 4.5,
        reviews: 78,
        providerId: 'prov_1',
        providerName: 'Happy Pets Shop',
        stock: 8
    },
    {
        id: 'prod_8',
        title: 'Natural Flea & Tick Shampoo',
        description: 'Safe and effective protection for your pets. Our plant-based formula kills fleas and ticks on contact while soothing irritated skin.\n\n• Contains Lemongrass and Cedarwood Oil\n• pH balanced for pets\n• No harsh chemicals or parabens\n• Safe for dogs and cats over 12 weeks old',
        price: 55.00,
        currency: 'SAR',
        country: 'Kuwait', // Different Country
        city: 'Kuwait City',
        category: 'healthcare',
        image: 'https://images.unsplash.com/photo-1583947582358-b875ae52519f?q=80&w=1000&auto=format&fit=crop',
        rating: 4.7,
        reviews: 189,
        providerId: 'prov_4',
        providerName: 'Pet Wellness Co.',
        stock: 15,
        reviewsData: [
            { id: 101, user: "Sarah M.", rating: 5, date: "2023-11-12", comment: "Works wonders! My dog stopped scratching within hours." },
            { id: 102, user: "Mike T.", rating: 4, date: "2023-10-05", comment: "Smells great, but a bit pricey." }
        ]
    }
];

// Helper to simulate network delay
const delay = (ms = 800) => new Promise(resolve => setTimeout(resolve, ms));


// Mock Orders Data
let ORDERS = [
    {
        id: '#ORD-7782',
        date: '2024-12-10',
        customer: 'Emily R.',
        status: 'Delivered',
        total: 145.50,
        currency: 'SAR',
        providerId: 'prov_1',
        items: [
            { title: 'Premium Dog Food (Chicken)', quantity: 1, price: 45.00 },
            { title: 'Indestructible Rubber Ball', quantity: 2, price: 15.00 }
        ]
    },
    {
        id: '#ORD-5591',
        date: '2024-11-25',
        customer: 'John D.',
        status: 'Processing',
        total: 299.00,
        currency: 'SAR',
        providerId: 'prov_1',
        items: [
            { title: 'Cat Scratching Post', quantity: 1, price: 120.00 },
            { title: 'Automatic Feeder', quantity: 1, price: 179.00 }
        ]
    }
];

export const marketplaceAPI = {
    /**
     * Get all products with optional filtering
     */
    getProducts: async (filters = {}) => {
        await delay();
        let result = [...PRODUCTS];

        if (filters.country) {
            result = result.filter(p => p.country === filters.country);
        }

        if (filters.city && filters.city !== 'all') {
            result = result.filter(p => p.city === filters.city);
        }

        if (filters.category && filters.category !== 'all') {
            result = result.filter(p => p.category === filters.category);
        }

        if (filters.search) {
            const query = filters.search.toLowerCase();
            result = result.filter(p =>
                p.title.toLowerCase().includes(query) ||
                p.description.toLowerCase().includes(query)
            );
        }

        return {
            status: 'success',
            data: result
        };
    },

    getCities: (country) => {
        if (country === 'Saudi Arabia') return ['Riyadh', 'Jeddah', 'Dammam', 'Mecca', 'Medina'];
        if (country === 'United Arab Emirates') return ['Dubai', 'Abu Dhabi', 'Sharjah'];
        if (country === 'Kuwait') return ['Kuwait City', 'Al Ahmadi'];
        return [];
    },

    /**
     * Get a single product by ID
     */
    getProductById: async (id) => {
        await delay(500);
        const product = PRODUCTS.find(p => p.id === id);
        if (!product) throw new Error('Product not found');
        return {
            status: 'success',
            data: product
        };
    },

    /**
     * Get products for a specific provider
     */
    getProviderListings: async (providerId = 'current_user') => {
        await delay();
        // Return items for 'prov_1' which represents the current user in this demo
        return {
            status: 'success',
            data: PRODUCTS.filter(p => p.providerId === 'prov_1')
        };
    },

    /**
     * Create a new order (Buyer Side)
     * Handles stock decrement and order creation
     */
    createOrder: async (orderData) => {
        await delay(1000);

        // 1. Verify stock for all items
        for (const item of orderData.items) {
            const productIndex = PRODUCTS.findIndex(p => p.id === item.id);
            if (productIndex === -1) throw new Error(`Product ${item.id} not found`);

            if (PRODUCTS[productIndex].stock < item.quantity) {
                return {
                    status: 'error',
                    message: `Not enough stock for ${PRODUCTS[productIndex].title}`
                };
            }
        }

        // 2. Decrement stock
        orderData.items.forEach(item => {
            const productIndex = PRODUCTS.findIndex(p => p.id === item.id);
            if (productIndex !== -1) {
                PRODUCTS[productIndex].stock -= item.quantity;
            }
        });

        // 3. Create Order Record
        const newOrder = {
            id: `#ORD-${Math.floor(1000 + Math.random() * 9000)}`,
            date: new Date().toISOString().split('T')[0],
            customer: 'You', // In real app, from user session
            status: 'Pending',
            ...orderData,
            providerId: 'prov_1' // Assign to our mock provider for demo
        };

        ORDERS.unshift(newOrder);

        return {
            status: 'success',
            data: newOrder
        };
    },



    /**
     * Get orders for the BUYER (Order History)
     */
    getOrders: () => {
        // Return all orders where customer is 'You' (or mocked user)
        // For this demo, we just return the ORDERS array filtering for the mock user if needed, 
        // but currently ORDERS has mixed data so we'll just return it all or filter by customer name.
        return ORDERS.filter(o => o.customer === 'You' || o.customer === 'Emily R.' || o.customer === 'John D.');
    },

    /**
     * Get orders for the provider dashboard
     */
    getProviderOrders: async () => {
        await delay();
        // Return orders for 'prov_1'
        return {
            status: 'success',
            data: ORDERS.filter(o => o.providerId === 'prov_1')
        };
    },

    /**
     * Update order status (Provider Side)
     */
    updateOrderStatus: async (orderId, newStatus) => {
        await delay(500);
        const index = ORDERS.findIndex(o => o.id === orderId);
        if (index !== -1) {
            ORDERS[index].status = newStatus;
            return { status: 'success', data: ORDERS[index] };
        }
        return { status: 'error', message: 'Order not found' };
    },

    /**
     * Create a new product listing
     */
    createProduct: async (productData) => {
        await delay(1000);
        const newProduct = {
            id: `prod_${Date.now()}`,
            ...productData,
            rating: 0,
            reviews: 0,
            providerId: 'prov_1', // Assign to current user
            providerName: 'Happy Pets Shop',
            stock: parseInt(productData.stock) || 0
        };
        PRODUCTS.unshift(newProduct);
        return {
            status: 'success',
            data: newProduct
        };
    },

    /**
     * Update an existing product
     */
    updateProduct: async (id, updates) => {
        await delay(1000);
        const index = PRODUCTS.findIndex(p => p.id === id);
        if (index === -1) throw new Error('Product not found');

        PRODUCTS[index] = { ...PRODUCTS[index], ...updates };
        return {
            status: 'success',
            data: PRODUCTS[index]
        };
    },

    deleteProduct: async (id) => {
        await delay(800);
        PRODUCTS = PRODUCTS.filter(p => p.id !== id);
        return {
            status: 'success',
            message: 'Product deleted successfully'
        };
    },

    /**
     * Submit a product review
     */
    addReview: async (productId, reviewData) => {
        await delay(600);
        const product = PRODUCTS.find(p => p.id === productId);
        if (!product) throw new Error('Product not found');

        const newReview = {
            id: Date.now(),
            user: "You", // Mock user
            date: new Date().toISOString().split('T')[0],
            ...reviewData
        };

        if (!product.reviewsData) product.reviewsData = [];
        product.reviewsData.unshift(newReview);

        // Recalculate rating
        const total = product.reviewsData.reduce((sum, r) => sum + r.rating, 0);
        product.rating = total / product.reviewsData.length;
        product.reviews = product.reviewsData.length;

        return {
            status: 'success',
            data: newReview
        };
    },

    /**
     * Get available categories
     */
    getCategories: () => {
        return [
            { id: 'all', label: 'All Items' },
            { id: 'food', label: 'Food & Treats' },
            { id: 'toys', label: 'Toys' },
            { id: 'accessories', label: 'Accessories' },
            { id: 'bedding', label: 'Bedding' },
            { id: 'habitats', label: 'Habitats & Cages' },
            { id: 'healthcare', label: 'Healthcare' }
        ];
    },

    /**
     * Get provider details for Storefront
     */
    getProviderDetails: async (providerId) => {
        await delay(600);
        // Mock data logic
        const providers = {
            'prov_1': {
                id: 'prov_1',
                name: 'Happy Pets Shop',
                description: 'Your one-stop shop for all things fluffy and cute. We specialize in organic food and premium accessories.',
                rating: 4.8,
                followers: 1250,
                joined: '2022',
                image: 'https://images.unsplash.com/photo-1556228578-8d84f5d4476e?q=80&w=200&auto=format&fit=crop',
                banner: 'https://images.unsplash.com/photo-1548767797-d8c844163c4c?q=80&w=1200&auto=format&fit=crop'
            },
            'prov_2': {
                id: 'prov_2',
                name: 'Paws & Play',
                description: 'Toys for tough chewers and active pets. Lets play!',
                rating: 4.9,
                followers: 890,
                joined: '2023',
                image: 'https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?q=80&w=200&auto=format&fit=crop',
                banner: 'https://images.unsplash.com/photo-1587559070757-f72a388edbba?q=80&w=1200&auto=format&fit=crop'
            },
            'prov_3': {
                id: 'prov_3',
                name: 'TechPets',
                description: 'Smart gadgets for modern pet parents.',
                rating: 4.5,
                followers: 540,
                joined: '2023',
                image: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=200&auto=format&fit=crop',
                banner: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?q=80&w=1200&auto=format&fit=crop'
            },
            'prov_4': {
                id: 'prov_4',
                name: 'Pet Wellness Co.',
                description: 'Holistic health and wellness products for your furry friends.',
                rating: 4.7,
                followers: 2100,
                joined: '2021',
                image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop',
                banner: 'https://images.unsplash.com/photo-1574158622682-e40e69881006?q=80&w=1200&auto=format&fit=crop'
            }
        };

        const provider = providers[providerId] || {
            id: providerId,
            name: 'Unknown Seller',
            description: 'This provider information is unavailable.',
            rating: 0,
            followers: 0,
            joined: 'Unknown',
            currency: 'SAR',
            image: 'https://via.placeholder.com/150',
            banner: 'https://via.placeholder.com/1200x300'
        };

        return {
            status: 'success',
            data: provider
        };
    },

    /**
     * Update provider details
     */
    updateProviderDetails: async (providerId, updates) => {
        await delay(800);
        // Mock update logic
        console.log(`Updating provider ${providerId} with`, updates);
        return {
            status: 'success',
            message: 'Store settings updated successfully',
            data: { ...updates }
        };
    },

    /**
     * Get exchange rates (Live)
     * Base: SAR
     */
    getExchangeRates: async () => {
        try {
            const response = await fetch('https://api.exchangerate-api.com/v4/latest/SAR');
            const data = await response.json();
            return {
                status: 'success',
                base: 'SAR',
                rates: data.rates
            };
        } catch (error) {
            console.error("Currency fetch error:", error);
            // Fallback rates
            return {
                status: 'success',
                base: 'SAR',
                rates: { SAR: 1, USD: 0.27, EUR: 0.25, GBP: 0.21 }
            };
        }
    },
};
